export const useMailTo = () => {
    // ---------------------- mail to ----------------
    const showMailTo = () => {
        window.open('mailto:hola@extendeal.com?subject=Extendeal Pharma | Contacto', '_blank');
    };

    return { showMailTo };
};
